import CartModel from '@/models/cart.model';

type Props = {
  slug: string;
  productId: string;
  demoId?: string;
  steppedDiscounts?: {
    needToNextStep: number;
    currentAmount: number;
    neededAmount: number;
    steps: {};
  };
  selectedAddons?: any;
  cart?: CartModel;
};

export type SelectedAddOns = {
  [key: string]: { selected: boolean; price: number; id?: string };
};

export enum ADDONS_ENUM {
  EXTRA_SUPPORT = 'extra-support',
  INSTALLATION = 'installation',
  REPEAT_PURCHASE = 'extra_license',
  SUBSCRIPTION_LIFETIME = 'subscription_lifetime',
  SUBSCRIPTION_ONE_YEAR = 'subscription_one_year',
  EXTRA_LICENSE = 'extra_license',
}

export default Props;
